export abstract class BaseSignalRStrategy {
    // Each strategy will implement this
    public abstract handleMessage(message: string): void;
    public abstract resetOnCompletionStart(): void;
}


export class StreamingSignalRStrategy extends BaseSignalRStrategy {
    private setCompletionMessage: React.Dispatch<React.SetStateAction<string>>;

    constructor(
        setCompletionMessage: React.Dispatch<React.SetStateAction<string>>
    ) {
        super();
        this.setCompletionMessage = setCompletionMessage;
    }

    public handleMessage(message: string) {
        this.setCompletionMessage(prev => prev + message);
    }

    public resetOnCompletionStart() {
        this.setCompletionMessage('');
    }
}


export class NonStreamingSignalRStrategy<T> extends BaseSignalRStrategy {

    private setCompletionResponse: React.Dispatch<React.SetStateAction<T | null>>;
    private setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
    constructor(
        setErrorMessage: (error: string) => void,
        setCompletionResponse: React.Dispatch<React.SetStateAction<T | null>>
    ) {
        super();
        this.setErrorMessage = setErrorMessage;
        this.setCompletionResponse = setCompletionResponse;
    }

    public handleMessage(message: string) {
        try {
            // currently non streaming response message needds to be json
            const response: T = JSON.parse(message);
            this.setCompletionResponse(response);
        } catch (e) {
            this.setErrorMessage('Response from AI not valid JSON. Please try again.');
        }

    }

    public resetOnCompletionStart() {
        this.setCompletionResponse(null);
    }
}

